export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <div
          className="w-full h-full bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: 'url(https://static.readdy.ai/image/2806d7657d5f4d36c9110f806a03accf/847b0e89c9a479336afdbb32ce8cb608.webp)'
          }}
        ></div>
        <div className="absolute inset-0 bg-black bg-opacity-60"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Professional Tree and Stump Management
          </h1>
          <p className="text-xl sm:text-2xl text-gray-200 mb-8 max-w-3xl mx-auto">
            Gavin Luke Tree and Stump Service is a family owned and operated business with over 25 years experience in the industry. Based in Nuriootpa, working throughout the northern suburbs of Adelaide, Gawler and the Barossa Valley.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={() => scrollToSection('quote')}
              className="bg-green-600 text-white hover:bg-green-700 px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              Get Free Quote
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-gray-800 px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              View Services
            </button>
          </div>

          <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-8 text-white">
            <div className="flex flex-col items-center">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mb-4">
                <i className="fas fa-shield-alt text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Fully Licensed and Insured</h3>
              <p className="text-gray-300">Complete protection for your peace of mind</p>
            </div>

            <div className="flex flex-col items-center">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mb-4">
                <i className="fas fa-clock text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">24/7 Emergency Service</h3>
              <p className="text-gray-300">Available when you need us most</p>
            </div>

            <div className="flex flex-col items-center">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mb-4">
                <i className="fas fa-leaf text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Eco-Friendly Methods</h3>
              <p className="text-gray-300">Sustainable practices for a greener future</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
